import { Component } from "@angular/core";
import { environment } from "@environments/environment";

@Component({
  selector: "app-container",
  standalone: true,
  imports: [],
  template: `
    <div class="container">
      <div class="content">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .container {
      width: 100%;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: auto;
      scrollbar-gutter: stable;
      padding: 0;
      margin: 0;
      background-image: url("${environment.baseRef}/assets/background/background-mobile.jpg");
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-attachment: fixed;

      @include screenWidth("from-desktop") {
        background-image: url("${environment.baseRef}/assets/background/background-desktop.jpg");
      }
    }

    /* WebKit-based browsers (Chrome, Edge, Safari, etc.) */
    .container::-webkit-scrollbar {
      width: 12px;
    }

    .container::-webkit-scrollbar-track {
      background: transparent;
    }

    .container::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.7);
      border-radius: 100px;
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.9);
    }

    /* Firefox */
    .container {
      scrollbar-width: auto;
      scrollbar-color: rgba(255, 255, 255, 0.7) transparent;
    }

    .content {
      position: relative;
      min-height: 100vh;
      width: 100%;
      overflow-y: hidden;

      display: flex;
      flex-direction: column;
      padding: 24px 24px 28px 24px;

      @include screenWidth("from-desktop") {
        padding: 52px;
      }
    }
  `,
})
export class Container {}
